<mat-card appearance="outlined" [ngStyle]="{ padding: '0' }">
  <div
    fxLayout="row"
    class="u-borderBottom-standard u-padding-0-24"
    [ngStyle]="{ height: '48px' }"
  >
    <app-form-template-title
      [text]="title.text"
      [primaryIcon]="title.primaryIcon"
      [secondaryIcon]="title.secondaryIcon"
      [ngStyle]="{ 'flex-grow': 1, 'flex-basis': 0 }"
      class="u-marginRight-16 u-display-block"
    >
    </app-form-template-title>
    <div [ngStyle]="{ 'flex-grow': 2, 'flex-basis': 0 }" fxLayout="row">
      <app-form-template-description
        [description]="description"
        class="u-width-100 color-grey-300 u-display-block"
      >
      </app-form-template-description>
      <div fxLayout="row" fxLayoutAlign="center center" class="u-height-100">
        <form novalidate [formGroup]="formGroup">
          <mat-slide-toggle
            *ngFor="let form of forms"
            [checked]="form.model"
            [formControlName]="form.updateKey"
          >
          </mat-slide-toggle>
        </form>
      </div>
    </div>
  </div>
</mat-card>
